import Data from "../types/Data";

export default function getVenmo(data: Data) {
  return data.venmo;
}
